import React from "react";
import { usePO } from "./usePO";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import moment from "moment";
import Select from "react-select";
import CloseLogo from "../../Assets/close_icon.png";
import DeleteIcon from "../../Assets/delete_icon.png";
import RefreshIcon from "../../Assets/refresh-icon.png";
import SearchLogo from "../../Assets/search-icon.png";
import { bulan, tahun, constCustomer } from "../../util/constant";
import { fmt, LEGEND, TABS } from "./poHelpers";
import PoInputTable from "./PoInputTable";
import PoMemoTab from "./PoMemoTab";
import PoSuratJalanManualTab from "./PoSuratJalanManualTab";
import { PoSuratJalanTab, PoCancelPopup, PoRiwayatTab } from "./PoSuratJalan";
import "./PO.css";

const selectStyles = (hasError) => ({
  control: (base) => ({
    ...base,
    height: 31,
    minHeight: 31,
    fontSize: 12,
    ...(hasError ? { border: "2px solid #d32f2f" } : {}),
  }),
  menuList: (base) => ({ ...base, fontSize: "12px" }),
  dropdownIndicator: (provided) => ({ ...provided, paddingTop: 2 }),
});

const CloseButton = ({ onClick }) => (
  <img
    style={{ width: 36, height: 36, cursor: "pointer" }}
    src={CloseLogo}
    alt="tutup"
    onClick={onClick}
  />
);

const PO = () => {
  const po = usePO();
  const {
    popUpNewPo,
    setPopUpNewPo,
    customerNewPo,
    setCustomerNewPo,
    noPo,
    setNoPo,
    noLine,
    setNoLine,
    kodeLine,
    setKodeLine,
    itemPo,
    setItemPo,
    totalPo,
    setTotalPo,
    jadwalKirim,
    addFields,
    removeFields,
    handleFormChange,
    handleCloseNewPo,
    handleTambahPo,
    dataListTempPo,
    handleDeleteTempPo,
    dateTemp,
    errIsEmpty,
    handleKirimPo,
    bulanPo,
    setBulanPo,
    tahunPo,
    setTahunPo,
    dataListBarangTemp,
    dataListPo,
    popUpPickTanggal,
    handleClosePopUpPickTanggal,
    pickData,
    pickTanggal,
    dateKirim,
    setDateKirim,
    jumlahKirim,
    setJumlahKirim,
    setIsRefresh,
    handleKirimEditTanggal,
    handlePickJenis,
    isMaju,
    isMundur,
    isBuatMemoKirim,
    setIsBuatMemoKirim,
    handleKirimBatal,
    popUpCatatan,
    setPopUpCatatan,
    customerCatatan,
    setCustomerCatatan,
    keteranganCatatan,
    setKeteranganCatatan,
    handleUpdateCatatan,
    handleDeleteCatatan,
    setIsRefreshCatatan,
    dataListCatatan,
    handlePickChecklist,
    dataSuratJalanTemp,
    dataPickMemoKirim,
    handleCloseMemoKirim,
    handleCancelPickChecklist,
    isPecah,
    setIsPecah,
    pecahNoPol,
    addFieldsPecah,
    removeFieldsPecah,
    handleFormChangePecah,
    isPecahPick,
    setIsPecahPick,
    handleClickPecah,
    dateMemoKirim,
    setDateMemoKirim,
    noPol,
    setNoPol,
    handleKirimNoPol,
    removeSpaces,
    subMenu,
    setSubMenu,
    filterDateMemoKirim,
    setFilterDateMemoKirim,
    filterCustomer,
    setFilterCustomer,
    valueSearch,
    setValueSearch,
    handleResetFilter,
    disabledButton,
    setDisabledButton,
    checkingRole,
    handleDeleteJadwal,
    errPecah,
    noSkk,
    setNoSkk,
    popUpImportPo,
    setPopUpImportPo,
    setFile,
    handleImportPo,
    handleExportTemplateImportPo,
    isEditPo,
    setIsEditPo,
    handleKirimEditPo,
    popUpCancel,
  } = po;

  const sortedTempDates = [...(dateTemp || [])].sort(
    (a, b) => Number(a.tanggal) - Number(b.tanggal)
  );

  const sortedTempPo = [...(dataListTempPo || [])].sort((a, b) =>
    a.customer < b.customer ? -1 : a.customer > b.customer ? 1 : 0
  );

  const sumJadwal = (jadwalKirim || []).reduce((s, a) => s + a.jumlah, 0);

  const customerFilterOptions = [
    ...new Set((dataListPo || []).map((e) => e.customer)),
  ];

  const itemLabel = (d) =>
    `${d.customer === "YBI" ? d.kodeBarang : ""} ${d.itemPo}`;

  return (
    <>
      {/* ================= POPUP IMPORT PO ================= */}
      {popUpImportPo ? (
        <PopUpComponent className="po-modal po-modal--sm">
          <div className="po-modal-head">
            <h3 className="po-modal-title">Import PO</h3>
            <CloseButton onClick={() => setPopUpImportPo(false)} />
          </div>
          <button
            className="po-btn po-btn--ghost"
            onClick={() => handleExportTemplateImportPo()}
          >
            Export Template
          </button>
          <div className="po-toolbar-group" style={{ marginTop: 12 }}>
            <input
              type="file"
              accept=".xls,.xlsx"
              onChange={(e) => setFile(e.target.files[0])}
            />
            <button
              className="po-btn po-btn--gold"
              onClick={() => handleImportPo()}
            >
              Import PO
            </button>
          </div>
        </PopUpComponent>
      ) : null}

      {/* ================= POPUP NEW PO ================= */}
      {popUpNewPo ? (
        <PopUpComponent className="po-modal po-modal--xl">
          <div className="po-modal-head">
            <h3 className="po-modal-title">PO Baru</h3>
            <CloseButton onClick={() => handleCloseNewPo()} />
          </div>

          <div className="po-form-row">
            <div className="po-field">
              <label className="po-label">Bulan</label>
              <select
                className="po-select"
                style={{ width: 96 }}
                value={bulanPo}
                onChange={(e) => setBulanPo(e.target.value)}
              >
                <option disabled>Pilih Bulan</option>
                {bulan.map((e) => (
                  <option key={e.value} value={e.value}>
                    {e.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="po-field">
              <label className="po-label">Tahun</label>
              <select
                className="po-select"
                style={{ width: 72 }}
                value={tahunPo}
                onChange={(e) => setTahunPo(e.target.value)}
              >
                <option disabled>Pilih Tahun</option>
                {tahun.map((e) => (
                  <option key={e} value={e}>
                    {e}
                  </option>
                ))}
              </select>
            </div>
            <div className="po-field">
              <label
                className={`po-label ${
                  errIsEmpty && customerNewPo === "Pilih Customer"
                    ? "po-label--err"
                    : ""
                }`}
              >
                Customer
              </label>
              <select
                className={`po-select ${
                  errIsEmpty && customerNewPo === "Pilih Customer"
                    ? "po-input--err"
                    : ""
                }`}
                style={{ width: 120 }}
                value={customerNewPo}
                onChange={(e) => setCustomerNewPo(e.target.value)}
              >
                <option disabled>Pilih Customer</option>
                {(constCustomer || []).map((ele) => (
                  <option key={ele} value={ele}>
                    {ele}
                  </option>
                ))}
              </select>
            </div>
            <div className="po-field">
              <label
                className={`po-label ${
                  errIsEmpty && !noPo ? "po-label--err" : ""
                }`}
              >
                No. PO
              </label>
              <input
                className={`po-input ${
                  errIsEmpty && !noPo ? "po-input--err" : ""
                }`}
                type="text"
                placeholder="KSB123456"
                value={noPo ? noPo : ""}
                onChange={(e) => setNoPo(e.target.value.toUpperCase())}
              />
            </div>
            <div className="po-field">
              <label className="po-label">No. Line</label>
              <input
                className="po-input"
                type="text"
                placeholder="30"
                style={{ width: 56 }}
                value={noLine ? noLine : ""}
                onChange={(e) => setNoLine(e.target.value.toUpperCase())}
              />
            </div>
            <div className="po-field">
              <label className="po-label">No. SKK</label>
              <input
                className="po-input"
                type="text"
                placeholder="123/TIM/2025"
                style={{ width: 110 }}
                value={noSkk ? noSkk : ""}
                onChange={(e) => setNoSkk(e.target.value.toUpperCase())}
              />
            </div>
            <div className="po-field">
              <label className="po-label">Kode Line</label>
              <input
                className="po-input"
                type="text"
                placeholder="PKXA123"
                style={{ width: 96 }}
                value={kodeLine ? kodeLine : ""}
                onChange={(e) => setKodeLine(e.target.value.toUpperCase())}
              />
            </div>
            <div className="po-field" style={{ zIndex: 16 }}>
              <label
                className={`po-label ${
                  errIsEmpty && !itemPo ? "po-label--err" : ""
                }`}
              >
                Item
              </label>
              <Select
                options={dataListBarangTemp && dataListBarangTemp.data}
                className="po-select-item"
                styles={selectStyles(errIsEmpty && !itemPo)}
                value={itemPo || ""}
                onChange={setItemPo}
              />
            </div>
            <div className="po-field">
              <label
                className={`po-label ${
                  errIsEmpty && !totalPo ? "po-label--err" : ""
                }`}
              >
                Total PO
              </label>
              <input
                className={`po-input ${
                  errIsEmpty && !totalPo ? "po-input--err" : ""
                }`}
                type="number"
                style={{ width: 96 }}
                placeholder="Total (Pcs)"
                value={totalPo ? totalPo : ""}
                onChange={(e) => setTotalPo(Number(e.target.value))}
                onWheel={(e) => e.target.blur()}
              />
            </div>
          </div>

          <label className="po-label">Jadwal Kirim</label>
          <div style={{ display: "flex", alignItems: "flex-end", gap: 12 }}>
            <div>
              {jadwalKirim.map((data, index) => (
                <div
                  key={index}
                  style={{ display: "flex", gap: 6, marginBottom: 6 }}
                >
                  <input
                    className="po-input po-input--date"
                    type="date"
                    name="date"
                    value={data.date}
                    onChange={(e) => handleFormChange(index, e)}
                  />
                  <input
                    className="po-input"
                    name="jumlah"
                    type="number"
                    placeholder="Jumlah Kirim (Pcs)"
                    value={data.jumlah > 0 ? data.jumlah : ""}
                    onChange={(e) => handleFormChange(index, e)}
                  />
                </div>
              ))}
            </div>
            <div className="po-toolbar-group" style={{ marginBottom: 6 }}>
              <button className="po-btn-square" onClick={() => removeFields()}>
                &#8722;
              </button>
              <button className="po-btn-square" onClick={() => addFields()}>
                &#43;
              </button>
              <b>{fmt(sumJadwal)}</b>
            </div>
          </div>

          <div className="po-actions-end">
            <button
              className="po-btn po-btn--success"
              disabled={disabledButton}
              onClick={() => {
                setDisabledButton(true);
                handleTambahPo();
              }}
            >
              Tambah
            </button>
          </div>

          <div
            className="po-table-wrap"
            style={{ marginTop: 12, maxHeight: "45vh" }}
          >
            <table className="po-table">
              <thead>
                <tr>
                  <th className="po-th">No.</th>
                  <th className="po-th">Cust</th>
                  <th className="po-th">No. PO</th>
                  <th className="po-th">Line</th>
                  <th className="po-th">SKK</th>
                  <th className="po-th">Kode Line</th>
                  <th className="po-th">Item</th>
                  <th className="po-th">Total</th>
                  {sortedTempDates.map((ele) => (
                    <th key={ele.date} className="po-th po-th--date">
                      {ele.tanggal}
                    </th>
                  ))}
                  <th className="po-th" />
                </tr>
              </thead>
              <tbody>
                {sortedTempPo.map((data, index) => (
                  <tr
                    key={data.id}
                    className={`po-row ${index % 2 ? "po-row--alt" : ""}`}
                  >
                    <td className="po-td">{index + 1}.</td>
                    <td className="po-td">{data.customer}</td>
                    <td className="po-td po-nowrap">{data.noPo}</td>
                    <td className="po-td">{data.noLine}</td>
                    <td className="po-td">{data.noSkk}</td>
                    <td className="po-td">{data.kodeLine}</td>
                    <td className="po-td">{itemLabel(data)}</td>
                    <td className="po-td po-nowrap">{fmt(data.jumlah)}</td>
                    {sortedTempDates.map((ele) => {
                      const found = data.jadwalKirim.find(
                        (o) => o.date === ele.date
                      );
                      return (
                        <td
                          key={ele.date}
                          className="po-td po-td--date"
                          style={{ cursor: "default" }}
                        >
                          {found && found.jumlah ? fmt(found.jumlah) : ""}
                        </td>
                      );
                    })}
                    <td className="po-td">
                      <img
                        className="po-icon-btn"
                        src={DeleteIcon}
                        alt="hapus"
                        onClick={() => handleDeleteTempPo(data.id)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {sortedTempPo.length > 0 ? (
            <div className="po-actions-end">
              <button
                className="po-btn po-btn--danger"
                disabled={disabledButton}
                onClick={() => {
                  setDisabledButton(true);
                  handleKirimPo();
                }}
              >
                Kirim
              </button>
            </div>
          ) : null}
        </PopUpComponent>
      ) : null}

      {/* ================= POPUP EDIT TANGGAL ================= */}
      {popUpPickTanggal ? (
        <PopUpComponent className="po-modal po-modal--sm">
          <div className="po-modal-head">
            <p style={{ margin: 0 }}>
              <b>{pickData.itemPo}</b> &emsp;{" "}
              {moment(pickTanggal.date).utcOffset("+0700").format("DD-MM-YYYY")}
            </p>
            <CloseButton onClick={() => handleClosePopUpPickTanggal()} />
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: 6,
            }}
          >
            <div className="po-check" onClick={() => handlePickJenis("mundur")}>
              <input type="checkbox" checked={!!isMundur} readOnly />
              <label>Mundur</label>
            </div>
            <div className="po-check" onClick={() => handlePickJenis("maju")}>
              <input type="checkbox" checked={!!isMaju} readOnly />
              <label>Maju</label>
            </div>
            <input
              type="date"
              className="po-input po-input--date"
              value={dateKirim || ""}
              onChange={(e) => setDateKirim(e.target.value)}
            />
            <input
              type="number"
              className="po-input"
              placeholder="Jumlah Kirim (Pcs)"
              value={jumlahKirim || ""}
              onChange={(e) => setJumlahKirim(Number(e.target.value))}
              onWheel={(e) => e.target.blur()}
            />
          </div>
          <p className="po-summary" style={{ margin: "12px 0 0" }}>
            {pickData.dateBefore &&
            (pickData.dateBefore.isMaju === true ||
              pickData.dateBefore.isMundur === true)
              ? `Punya PO Tgl : ${moment(pickData.dateBefore.dateBefore)
                  .utcOffset("+0700")
                  .format("DD-MM-YYYY")}`
              : ""}
          </p>
          <div className="po-actions-end">
            <button
              className="po-btn po-btn--warning"
              disabled={disabledButton}
              onClick={() => {
                setDisabledButton(true);
                handleDeleteJadwal();
              }}
            >
              Delete Jadwal
            </button>
            {pickData && pickData.dateBefore ? (
              <button
                className="po-btn po-btn--danger"
                disabled={disabledButton}
                onClick={() => {
                  setDisabledButton(true);
                  handleKirimBatal();
                }}
              >
                PO Batal
              </button>
            ) : null}
            <button
              className="po-btn po-btn--success"
              disabled={disabledButton}
              onClick={() => {
                setDisabledButton(true);
                handleKirimEditTanggal();
              }}
            >
              Kirim
            </button>
          </div>
        </PopUpComponent>
      ) : null}

      {/* ================= POPUP CATATAN ================= */}
      {popUpCatatan ? (
        <PopUpComponent className="po-modal po-modal--sm">
          <div className="po-modal-head">
            <div className="po-toolbar-group">
              <input
                className="po-input po-input--date"
                type="date"
                value={filterDateMemoKirim}
                onChange={(e) => setFilterDateMemoKirim(e.target.value)}
              />
              <select
                className="po-select"
                style={{ width: 120 }}
                value={customerCatatan}
                onChange={(e) => setCustomerCatatan(e.target.value)}
              >
                <option disabled>Pilih Customer</option>
                {(constCustomer || []).map((ele) => (
                  <option key={ele} value={ele}>
                    {ele}
                  </option>
                ))}
              </select>
            </div>
            <CloseButton onClick={() => setPopUpCatatan(false)} />
          </div>

          <div className="po-toolbar-group">
            <input
              className="po-input"
              type="text"
              placeholder="Catatan"
              style={{ width: "62%" }}
              value={keteranganCatatan}
              onChange={(e) =>
                setKeteranganCatatan(e.target.value.toUpperCase())
              }
            />
            <button
              className="po-btn po-btn--success"
              disabled={disabledButton}
              onClick={() => {
                setDisabledButton(true);
                handleUpdateCatatan();
              }}
            >
              Update
            </button>
            <img
              className="po-refresh"
              src={RefreshIcon}
              alt="refresh"
              onClick={() => setIsRefreshCatatan(true)}
            />
          </div>

          <div>
            {(dataListCatatan || []).map((obj) =>
              obj.data.length > 0 ? (
                <div key={obj.company}>
                  <p style={{ margin: "12px 0 6px", fontWeight: "bold" }}>
                    {obj.company}
                  </p>
                  {obj.data.map((ele, index) => (
                    <div
                      key={ele.id}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ display: "flex", gap: 6 }}>
                        <p style={{ margin: "6px 0" }}>{index + 1}.</p>
                        <p style={{ margin: "6px 0" }}>{ele.desc}</p>
                      </div>
                      <img
                        className="po-icon-btn"
                        src={DeleteIcon}
                        alt="hapus"
                        onClick={() => handleDeleteCatatan(ele.id)}
                      />
                    </div>
                  ))}
                </div>
              ) : null
            )}
          </div>
        </PopUpComponent>
      ) : null}

      {/* ================= POPUP BUAT MEMO (dari tabel PO) ================= */}
      {isBuatMemoKirim ? (
        <PopUpComponent className="po-modal po-modal--xl">
          <div className="po-modal-head">
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: 6,
              }}
            >
              {!isPecah ? (
                <>
                  <input
                    className="po-input po-input--date"
                    type="date"
                    value={dateMemoKirim}
                    onChange={(e) => setDateMemoKirim(e.target.value)}
                  />
                  <input
                    name="noPol"
                    className="po-input"
                    type="text"
                    value={noPol || ""}
                    onChange={(e) =>
                      removeSpaces(e.target.value.toUpperCase(), setNoPol)
                    }
                    placeholder="Contoh NoPol: B123AB"
                  />
                </>
              ) : null}
              <div className="po-check" onClick={() => setIsPecah(!isPecah)}>
                <input type="checkbox" checked={isPecah} readOnly />
                <label>Pecah Mobil</label>
              </div>
            </div>
            <CloseButton onClick={() => handleCloseMemoKirim()} />
          </div>

          {errPecah ? (
            <p className="po-error">
              Jumlah Total <b>SETELAH PECAH</b> harus sama dengan{" "}
              <b>SEBELUM PECAH</b>!
            </p>
          ) : null}

          {isPecah ? (
            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                gap: 12,
                marginBottom: 8,
              }}
            >
              <div>
                {pecahNoPol.map((data, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", gap: 6, marginBottom: 6 }}
                  >
                    <input
                      className="po-input po-input--date"
                      type="date"
                      name="date"
                      value={data.date}
                      onChange={(e) => handleFormChangePecah(index, e, "date")}
                    />
                    <input
                      className={`po-input ${errPecah ? "po-input--err" : ""}`}
                      name="jumlah"
                      type="number"
                      placeholder="Jumlah (Pcs)"
                      value={data.jumlah || ""}
                      onChange={(e) =>
                        handleFormChangePecah(index, e, "jumlah")
                      }
                    />
                    <input
                      className="po-input"
                      name="noPol"
                      type="text"
                      value={data.noPol}
                      placeholder="Contoh : B123ABC"
                      onChange={(e) => handleFormChangePecah(index, e, "noPol")}
                    />
                  </div>
                ))}
              </div>
              <div className="po-toolbar-group" style={{ marginBottom: 6 }}>
                <button
                  className="po-btn-square"
                  onClick={() => removeFieldsPecah()}
                >
                  &#8722;
                </button>
                <button
                  className="po-btn-square"
                  onClick={() => addFieldsPecah()}
                >
                  &#43;
                </button>
                <button
                  className="po-btn po-btn--success po-btn--sm"
                  onClick={() => handleClickPecah()}
                >
                  Pecah
                </button>
              </div>
            </div>
          ) : null}

          <div className="po-modal-split">
            <div style={{ width: "45%" }}>
              <p style={{ margin: "0 0 6px" }}>
                <b>OPEN PO</b>
              </p>
              <div className="po-table-wrap" style={{ maxHeight: "68vh" }}>
                <table className="po-table">
                  <thead>
                    <tr>
                      <th className="po-th">No.</th>
                      <th className="po-th">TGL</th>
                      <th className="po-th">ITEM</th>
                      <th className="po-th">NO. PO</th>
                      <th className="po-th">CUST</th>
                      <th className="po-th">JML</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(dataSuratJalanTemp || []).map((data, index) => {
                      const picked = isPecahPick && isPecahPick.index === index;
                      return (
                        <tr
                          key={index}
                          className={`po-tr ${
                            picked
                              ? "po-tr--picked"
                              : index % 2
                              ? "po-tr--alt"
                              : ""
                          }`}
                          onClick={() =>
                            isPecah
                              ? setIsPecahPick({ index: index, data: data })
                              : handlePickChecklist(data)
                          }
                        >
                          <td className="po-td">{index + 1}.</td>
                          <td className="po-td">
                            {moment(data.date).format("DD-MM-YY")}
                          </td>
                          <td className="po-td">{itemLabel(data)}</td>
                          <td className="po-td">{data.noPo}</td>
                          <td className="po-td">{data.customer}</td>
                          <td className="po-td po-nowrap">
                            {fmt(data.jumlah)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            <div style={{ width: "55%" }}>
              <p style={{ margin: "0 0 6px" }}>
                <b>MEMO KIRIM</b>
              </p>
              <div className="po-table-wrap" style={{ maxHeight: "68vh" }}>
                <table className="po-table">
                  <thead>
                    <tr>
                      <th className="po-th">No.</th>
                      <th className="po-th">TGL</th>
                      <th className="po-th">ITEM</th>
                      <th className="po-th">NO. PO</th>
                      <th className="po-th">CUST</th>
                      <th className="po-th">JML</th>
                      <th className="po-th">No.Pol</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(dataPickMemoKirim || []).map((data, index) => (
                      <tr
                        key={index}
                        className={`po-tr ${index % 2 ? "po-tr--alt" : ""}`}
                        onClick={() => handleCancelPickChecklist(data)}
                      >
                        <td className="po-td">{index + 1}.</td>
                        <td className="po-td">
                          {moment(data.dateKirimFinal).format("DD-MM-YY")}
                        </td>
                        <td className="po-td">{itemLabel(data)}</td>
                        <td className="po-td">{data.noPo}</td>
                        <td className="po-td">{data.customer}</td>
                        <td className="po-td po-nowrap">{fmt(data.jumlah)}</td>
                        <td className="po-td">{data.noPol}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="po-actions-end">
            <button
              className="po-btn po-btn--danger"
              disabled={disabledButton}
              onClick={() => {
                setDisabledButton(true);
                handleKirimNoPol();
              }}
            >
              Buat Memo
            </button>
          </div>
        </PopUpComponent>
      ) : null}

      {/* ================= POPUP TIKET CANCELLATION ================= */}
      {popUpCancel ? <PoCancelPopup po={po} /> : null}

      {/* ================= HALAMAN ================= */}
      <div className="po-root">
        <div className="po-header">
          <h1 className="po-title">List PO</h1>
          {checkingRole ? (
            <div className="po-header-actions">
              <button
                className="po-btn po-btn--warning"
                onClick={() => setPopUpImportPo(true)}
              >
                Import
              </button>
              <button
                className="po-btn po-btn--primary"
                onClick={() => setPopUpNewPo(true)}
              >
                + New PO
              </button>
            </div>
          ) : null}
        </div>

        <div className="po-tabs" role="tablist">
          {TABS.map(([key, label]) => (
            <button
              key={key}
              role="tab"
              aria-selected={subMenu === key}
              className={`po-tab ${
                key === "SJManual" ? "po-tab--manual" : ""
              } ${subMenu === key ? "po-tab--active" : ""}`}
              onClick={() => setSubMenu(key)}
            >
              {label}
            </button>
          ))}
        </div>

        {subMenu === "Input" ? (
          <>
            <div className="po-legend">
              {LEGEND.map(([key, label]) => (
                <div className="po-legend-item" key={key}>
                  <span className={`po-chip po-st--${key}`}>200</span>
                  {label}
                </div>
              ))}
            </div>

            <div className="po-toolbar">
              <div className="po-toolbar-group">
                <div className="po-search">
                  <input
                    className="po-search-input"
                    type="text"
                    placeholder="Cari barang / No. PO"
                    value={valueSearch}
                    onChange={(e) => setValueSearch(e.target.value)}
                  />
                  <p className="po-search-icon">
                    <img src={SearchLogo} alt="cari" />
                  </p>
                </div>
                <select
                  className="po-select"
                  style={{ width: 96 }}
                  value={bulanPo}
                  onChange={(e) => setBulanPo(e.target.value)}
                >
                  <option disabled>Pilih Bulan</option>
                  {bulan.map((ele) => (
                    <option key={ele.value} value={ele.value}>
                      {ele.name}
                    </option>
                  ))}
                </select>
                <select
                  className="po-select"
                  style={{ width: 72 }}
                  value={tahunPo}
                  onChange={(e) => setTahunPo(e.target.value.toString())}
                >
                  <option disabled>Pilih Tahun</option>
                  {tahun.map((ele) => (
                    <option key={ele} value={ele}>
                      {ele}
                    </option>
                  ))}
                </select>
                <select
                  className="po-select"
                  style={{ width: 120 }}
                  value={filterCustomer}
                  onChange={(e) => setFilterCustomer(e.target.value)}
                >
                  <option disabled>Pilih Customer</option>
                  {customerFilterOptions.map((c) => (
                    <option key={c} value={c}>
                      {c}
                    </option>
                  ))}
                </select>
                <span
                  className="po-link-btn"
                  onClick={() => handleResetFilter()}
                >
                  Reset
                </span>
                <img
                  className="po-refresh"
                  src={RefreshIcon}
                  alt="refresh"
                  onClick={() => setIsRefresh(true)}
                />
              </div>

              {checkingRole ? (
                <div className="po-toolbar-group">
                  {!isEditPo ? (
                    <button
                      className="po-btn po-btn--ghost"
                      onClick={() => setIsEditPo(true)}
                    >
                      Edit PO
                    </button>
                  ) : (
                    <button
                      className="po-btn po-btn--danger"
                      onClick={() => handleKirimEditPo()}
                    >
                      Kirim
                    </button>
                  )}
                  <button
                    className="po-btn po-btn--primary"
                    onClick={() => setIsBuatMemoKirim(true)}
                  >
                    Buat Memo
                  </button>
                </div>
              ) : null}
            </div>

            <PoInputTable po={po} />
          </>
        ) : subMenu === "Memo" ? (
          <PoMemoTab po={po} />
        ) : subMenu === "SuratJalan" ? (
          <PoSuratJalanTab po={po} />
        ) : subMenu === "SJManual" ? (
          <PoSuratJalanManualTab po={po} />
        ) : subMenu === "Riwayat" ? (
          <PoRiwayatTab po={po} />
        ) : null}
      </div>
    </>
  );
};
export default PO;
